/* @flow */
import * as React from 'react';
import { capitalize } from 'lodash';

import TextBadge from 'components/TextBadge';

import type { TextBadgeColor, TextBadgeTextColor } from 'components/TextBadge';

type BadgeMap = {
  [string]: {
    textColor: TextBadgeTextColor,
    color: TextBadgeColor,
  },
};

type Props = {
  content: string,
  color: TextBadgeColor,
  textColor: TextBadgeTextColor,
};

function TextBadgeCell({ content, color, textColor }: Props) {
  return (
    <TextBadge textSize="xxxxsmall" textWeight="normal" textColor={textColor} color={color}>
      {capitalize(content)}
    </TextBadge>
  );
}

export function getTextBadgeCellGenerator(fieldName: string, badgeMap: BadgeMap) {
  return (data: Object) => {
    const content = data[fieldName];

    if (!content) {
      return <span />;
    }

    return (
      <TextBadgeCell
        content={content}
        textColor={badgeMap[content] ? badgeMap[content].textColor : 'white'}
        color={badgeMap[content] ? badgeMap[content].color : 'eclipse'}
      />
    );
  };
}
